module.exports = __webpack_public_path__ + "media/images/flags/CG-e120b2960791a302fd83f54101d2e54d.svg";